import PengaturanDimensiConfig from "../../../../../components/categories/siakad/laporan_adab/pengaturan_dimensi/HomeConfigDimensi";
export default function Home() {
  
  return (
    <PengaturanDimensiConfig />
  );
}
